import { successLogStyle, warningLogStyle, wsFunctionTypes } from "../constants/global.vars";
import { Storage } from "./localstorege.service";
import { auth, authSubject } from "../store/auth.store";
import { toast } from "react-toastify";
import { ConnectionStatus, homeSliderSubject, homeSlides, supportTicketWsSubject } from "../store/misc.store";
import { getNews, showProfessionModalWss } from "./misc.functions";
import { AuthService, LoginFromWhere } from "./auth.service";
import { financialValidationService } from "../pages/login/financial.validation.pending";

export class WebSocketService {
  public wsHandler: any;
  public wsUrl: any;

  public user(token: any = null) {
    if (token) {
      try {
        const _message: any = {
          $type: "setUser",
          data: token,
        };
        this.wsHandler.send(JSON.stringify({ type: _message }));
      } catch (e) {
        console.error("web-socket service send Message ", e);
      }
    }
  }

  public setFinancialValidationListener(tc_id: string) {
    try {
      const _message: any = {
        $type: "setFinancialValidationListener",
        data: tc_id,
      };
      this.wsHandler.send(JSON.stringify({ type: _message }));
    } catch (e) {
      console.error("web-socket service send Message ", e);
    }
  }

  public checkauth() {
    try {
      const _message: any = {
        $type: "checkAuth",
      };
      this.wsHandler.send(JSON.stringify({ type: _message }));
    } catch (e) {
      console.error("web-socket service send Message ", e);
    }
  }

  public connect(url: string) {
    this.wsUrl = url;
    this.wsHandler = new WebSocket(this.wsUrl);
    this.wsHandler.onopen = () => {
      console.info("%c* websocket servis connected", successLogStyle);
      ConnectionStatus.isConnected = true;
      this.user(Storage.get("token"));
      const data = Storage.get("financial_validation_message_data");
      if (data) {
        const tc_id = JSON.parse(data).key;
        this.setFinancialValidationListener(tc_id);
      }
    };

    this.wsHandler.onmessage = (e: any) => {
      this.handleMessage(JSON.parse(e.data));
    };

    this.wsHandler.onclose = () => {
      console.info("%c* websocket servis connection down", warningLogStyle);
      this.wsHandler = null;
      setTimeout(() => {
        this.connect(this.wsUrl);
      }, 2000);
    };

    return this.wsHandler;
  }

  private handleMessage(message: any) {
    if (wsFunctionTypes.includes(message.type)) {
      eval(`this.${message.type}`)(message.data || message);
    }
  }

  supportTicketSaved(data: any) {
    supportTicketWsSubject.next(data);
  }

  checkAuth(data: any) {
    if (auth && auth.member && auth.member.id) {
      for (const [k, v] of Object.entries(data)) {
        // if (k!= 'profession') {
        auth.member[k] = v;
        // }
      }
      Storage.set("member", auth.member);
      authSubject.next({ action: "checkAuth" });

      if (auth.member.profession === null || auth.member.profession === undefined) {
        showProfessionModalWss();
      }
    }

  }

  newNotification(data: any) {
    toast.info(data.header);
    auth.member.unread_notification_count = data.total;
    authSubject.next({ action: "newNotification" });
  }

  updateSlide(data: any) {
    homeSlides.splice(0, homeSlides.length);
    homeSlides.push(...data);
    homeSliderSubject.next();
  }

  updateNews(data: any) {
    getNews();
  }

  accountApproved(data: any) {

  }

  updateBalance(data: any) {
    auth.member.balance_point = data.balance_point;
    auth.member.balance_debit = data.balance_debit;
    auth.member.balance_point_available = data.balance_point_available;
    auth.member.balance_debit_available = data.balance_debit_available;

    Storage.set("member", auth.member);
    authSubject.next({ action: "checkAuth" });
  }

  financialValidationListenerApproved(data: any) {

  }

  async financial_validation(data: any) {
    if (data.status === "success") {
      const authService = new AuthService();
      await authService.login({
        user: financialValidationService.data.tc_id || financialValidationService.data.user,
        password: financialValidationService.data.password,
        remember: financialValidationService.data.remember,
      }, LoginFromWhere.WS);
    }
  }
}

export const wssProvider = new WebSocketService();













